import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Uncaught render error:", error, info);
  }

  private handleReset = (): void => {
    this.setState({ error: null });
  };

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="page">
          <main className="shell">
            <section className="panel">
              <div className="status error" role="alert">
                <p className="error-title">문제가 발생했어요</p>
                <p>페이지를 불러오는 중 예기치 못한 오류가 발생했습니다.</p>
                <button type="button" className="linkish" onClick={this.handleReset}>
                  다시 시도
                </button>
              </div>
            </section>
          </main>
        </div>
      );
    }
    return this.props.children;
  }
}
